import { render, staticRenderFns } from "./PosSideBarElement.vue?vue&type=template&id=d2fd1208&scoped=true&"
import script from "./PosSideBarElement.vue?vue&type=script&lang=js&"
export * from "./PosSideBarElement.vue?vue&type=script&lang=js&"
import style0 from "./PosSideBarElement.vue?vue&type=style&index=0&id=d2fd1208&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fd1208",
  null
  
)

export default component.exports